import Vue from 'vue'

import vueScrollbarDirective from 'vue-scrollbar-directive'

/**
 * @deprecated
 * @todo Refactor and remove file
 */
Vue.use(vueScrollbarDirective)
